import {
  BookingAuthMethodQuery,
  BookingAuthMethodQueryVariables,
  BookingAuthMethodDocument,
  MutationCreateSoftAmendmentArgs,
  CreateSoftAmendmentMutation,
  CreateSoftAmendmentDocument,
  MutationAcceptAmendmentArgs,
  AcceptAmendmentMutation,
  AcceptAmendmentDocument,
  AmendmentQueryVariables,
  AmendmentQuery,
  AmendmentDocument,
  MutationCreateCancellationArgs,
  CreateCancellationMutation,
  CreateCancellationDocument,
  GetCancellationQueryVariables,
  GetCancellationQuery,
  GetCancellationDocument,
  MutationAcceptCancellationArgs,
  AcceptCancellationMutation,
  AcceptCancellationDocument,
  MutationAddCreditCardArgs,
  AddCreditCardMutation,
  AddCreditCardDocument,
  PaymentMethodAmendmentQueryVariables,
  PaymentMethodAmendmentQuery,
  PaymentMethodAmendmentDocument,
  MutationCreateDateAmendmentArgs,
  CreateDateAmendmentMutation,
  CreateDateAmendmentDocument,
  AvailabilityCalendarQueryVariables,
  AvailabilityCalendarQuery,
  AvailabilityCalendarDocument,
} from './generated';

import { createQuery, createMutation } from './helpers';

// Auth

export const getBookingAuthMethod = createQuery<BookingAuthMethodQueryVariables, BookingAuthMethodQuery>(BookingAuthMethodDocument);

// Soft Amendment

export const createSoftAmendment = createMutation<MutationCreateSoftAmendmentArgs, CreateSoftAmendmentMutation>(
  CreateSoftAmendmentDocument,
);

// Amendment

export const createDateAmendment = createMutation<MutationCreateDateAmendmentArgs, CreateDateAmendmentMutation>(
  CreateDateAmendmentDocument,
);

export const acceptAmendment = createMutation<MutationAcceptAmendmentArgs, AcceptAmendmentMutation>(AcceptAmendmentDocument);

export const getAmendment = createQuery<AmendmentQueryVariables, AmendmentQuery>(AmendmentDocument);

// Cancellation

export const createCancellation = createMutation<MutationCreateCancellationArgs, CreateCancellationMutation>(CreateCancellationDocument);

export const getCancellation = createQuery<GetCancellationQueryVariables, GetCancellationQuery>(GetCancellationDocument);

export const acceptCancellation = createMutation<MutationAcceptCancellationArgs, AcceptCancellationMutation>(AcceptCancellationDocument);

// Add credit card

export const addCreditCard = createMutation<MutationAddCreditCardArgs, AddCreditCardMutation>(AddCreditCardDocument);

export const getPaymentMethodAmendment = createQuery<PaymentMethodAmendmentQueryVariables, PaymentMethodAmendmentQuery>(
  PaymentMethodAmendmentDocument,
);

// Availability Calendar

export const getAvailabilityCalendar = createQuery<AvailabilityCalendarQueryVariables, AvailabilityCalendarQuery>(
  AvailabilityCalendarDocument,
);
